import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import './button.css';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.padding,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
    },
    chartTitle: { color: theme.palette.text.primary, fontSize: 15, fontWeight: 800, marginBottom: 14 },
    filterRow: { marginBottom: 18, alignItems: "center" },
    filterButton: { background: "linear-gradient(135deg,#F2D675,#D4AF37)", color: "#171306", fontWeight: 800, textTransform: "none", borderRadius: 10, minHeight: 38, padding: "0 18px", boxShadow: "0 6px 16px rgba(212,175,55,.24)", "&:hover": { background: "linear-gradient(135deg,#F7E5A2,#C59B24)" } },
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: false,
        },
        datalabels: {
            display: true,
            anchor: 'end',
            offset: -2,
            align: "start",
            color: "#07110C",
            textStrokeWidth: 0,
            font: {
                size: 12,
                weight: "bold"

            },
        },
        tooltip: { backgroundColor: "#111113", titleColor: "#F2D675", bodyColor: "#FFFFFF", padding: 12, cornerRadius: 10 }
    },
    scales: {
        x: { grid: { display: false }, border: { display: false }, ticks: { color: "#667085", font: { size: 11 } } },
        y: { beginAtZero: true, grid: { color: "rgba(16,24,40,.07)" }, border: { display: false }, ticks: { color: "#667085", precision: 0 } }
    },
};

export const ChatsUser = ({ initialDate, finalDate, refreshKey = 0 }) => {
    const classes = useStyles();
    const [ticketsData, setTicketsData] = useState({ data: [] });

    useEffect(() => {
        if (initialDate && finalDate) {
            handleGetTicketsInformation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialDate, finalDate, refreshKey]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => item.nome),
        datasets: [
            {
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.quantidade
                }),
                backgroundColor: "#D4AF37",
                borderColor: "#8A6809",
                borderWidth: 1,
                borderRadius: 8,
                borderSkipped: false,
                maxBarThickness: 48,
            },

        ],
    };

    const handleGetTicketsInformation = async () => {
        try {

            const { data } = await api.get('/dashboard/ticketsUsers', {
                params: { initialDate, finalDate }
            });
            setTicketsData(data);
        } catch (error) {
            toast.error('Erro ao buscar informações dos tickets');
        }
    }

    return (
        <>
            <Typography component="h2" className={classes.chartTitle}>
                {i18n.t("dashboard.users.totalCallsUser")}
            </Typography>

            <Typography style={{ fontSize: 12, color: "#667085", marginBottom: 16 }}>
                Período global: {initialDate} até {finalDate}
            </Typography>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '290px' }} />
        </>
    );
}
